import { render, staticRenderFns } from "./TableTrainees.vue?vue&type=template&id=8041a732&"
import script from "./TableTrainees.vue?vue&type=script&lang=js&"
export * from "./TableTrainees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports